<div class="d-grid grid-column gp-20 whiteBox">
  <div class="d-flex flex-column justify-content-center align-items-start w-100 list-of-vehicle-validops">
    <div class="position-relative mt-3">
      <img *ngIf="content?.image" src="{{ content?.image }}" class="v-image" [alt]="pageType" (load)="onImageLoad()"
      (error)="onImageError(content)">
      <img *ngIf="!content?.image" [src]="content?.defaultImage" class="v-image" [alt]="pageType">
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center w-100 mt-3">
    <div>
      <div class="tile-data-cp">
        <div class="d-flex gap-2">
          <div class="validops-chips" *ngIf="content?.category">{{content?.category}}</div>
          <div class="validops-chips" *ngIf="content?.secondaryDetails?.['type']">{{content?.secondaryDetails?.['type'] | titlecase}}</div>
        </div>
        <div class="details-font-validops uni-details-font">{{ content?.name }} / {{ content?.primaryDetails?.['make'] }} </div>
        <div class="details-font-validops uni-details-font " [title]="content?.primaryDetails?.['model']">{{ content?.primaryDetails?.['model'] }}</div>
        <div class="details-sub-font-validops uni-details-sub-font">
          <div>
            <img src="../../../../assets/images/validops-fueltype.svg" alt="Fuel Type" />
            {{ content?.secondaryDetails?.['fuelType'] }}
          </div>
          <!-- <div class="d-flex">
            <img src="../../../../assets/images/validops-location.svg" alt="Location" />
            <span class="ellipsis-text" [title]="content?.location ?? 'Location'">{{ content?.location ?? 'Location' }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>